// ========================================================
// FAST HIT Website — Coming Soon / Under Development Page
// ========================================================

import { Link } from 'react-router-dom';
import { Sparkles, ArrowLeft, Radio, Download, Mail } from 'lucide-react';

type PlaceholderPageProps = {
  title: string;
  description?: string;
  phase?: number;
};

export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  const is404 = title.includes('404');

  return (
    <div className="empty-state" style={{ minHeight: '65vh', padding: 'var(--sp-12) var(--sp-4)', textAlign: 'center' }}>
      <div className="empty-state__icon" style={{ background: 'rgba(255, 77, 0, 0.1)', color: 'var(--color-primary, #ff4d00)', margin: '0 auto var(--sp-4)' }}>
        <Sparkles size={32} />
      </div>
      <h1 className="empty-state__title" style={{ fontSize: 'var(--fs-2xl)', fontWeight: 800, marginBottom: 'var(--sp-2)' }}>
        {title}
      </h1>
      <p className="empty-state__description" style={{ maxWidth: '520px', margin: '0 auto var(--sp-6)', color: 'var(--color-text-secondary)' }}>
        {description || 'This feature is currently under active development. FastHit is continually expanding with new capabilities for players and organizers.'}
      </p>

      {!is404 && (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'rgba(0, 217, 245, 0.1)', color: 'var(--color-cyan, #00d9f5)', padding: '4px 12px', borderRadius: '100px', fontSize: '12px', fontWeight: 600, marginBottom: 'var(--sp-6)' }}>
          <span>● FastHit Rolling Release</span>
        </div>
      )}

      <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap', marginTop: 'var(--sp-2)' }}>
        <Link to="/" className="btn btn--secondary">
          <ArrowLeft size={16} />
          Back to Home
        </Link>
        <Link to="/live-scores" className="btn btn--outline">
          <Radio size={16} />
          Live Matches
        </Link>
        {title.toLowerCase().includes('download') ? (
          <a href="https://fasthit.in/app-release.apk" className="btn btn--primary" download>
            <Download size={16} />
            Direct APK Download
          </a>
        ) : (
          <a href="mailto:support@fasthit.in" className="btn btn--outline">
            <Mail size={16} />
            Contact Support
          </a>
        )}
      </div>
    </div>
  );
}

export default PlaceholderPage;
